module.exports = __webpack_public_path__ + "static/media/div.c23ccb71.png";